import styled from "styled-components";
import media from "responsive";
import MenuCard from "components/Home/MenuCard";
import { useMenuData } from "hooks/useMenuData";

export default function Signature() {
  const { signatureItems } = useMenuData();

  return (
    <Container>
      <Heading>Signature Dishes</Heading>
      <MenuContainer>
        {signatureItems.length === 0 && <p>No menu items found...</p>}
        {signatureItems.map((item, index) => (
          <MenuCard
            key={item.id || index}
            name={item.signatureMetadata.name || item.name}
            description={item.signatureMetadata.desc}
            price={item.price}
            img={item.signatureMetadata.img}
          />
        ))}
      </MenuContainer>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 50px 0;
  background-color: #fbf1dd;
`;

const MenuContainer = styled.div`
  width: 100%;
  max-width: 1200px;  // Limit the maximum width to avoid stretching on large screens
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  padding: 0 10px;   // Add some horizontal padding to avoid content sticking to the sides
`;

const Heading = styled.h1`
  font-weight: bold;
  color: #05493c;
  font-size: 3rem;
  text-align: center;
  margin-bottom: 20px;

  ${media.tabletL`
    font-size: 2.7rem;
    margin-bottom: 15px;
  `}

  ${media.tablet`
    font-size: 2.2rem;
  `}

  ${media.mobileL`
    font-size: 1.7rem;
  `}

  ${media.mobileM`
    font-size: 1.5rem;`}

  ${media.galaxyFold`
    font-size: 1.3rem;
  `}
`;
